import { Button, Modal, Stack, Text } from "@assetwatch/ui";

export function DeleteProcedureModal({
  error,
  isPending,
  onConfirm,
  onOpenChange,
  open,
  title,
}: {
  error: string | null;
  isPending: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  title: string;
}) {
  return (
    <Modal
      dismissible={!isPending}
      footer={
        <>
          <Button
            disabled={isPending}
            onClick={() => onOpenChange(false)}
            variant="outline"
          >
            Cancel
          </Button>
          <Button
            intent="destructive"
            loading={isPending}
            loadingText="Deleting"
            onClick={onConfirm}
          >
            Delete
          </Button>
        </>
      }
      onOpenChange={onOpenChange}
      open={open}
      title="Delete procedure?"
    >
      <Stack gap={16}>
        <Text>
          {`Delete "${title}"? It will be removed from the Procedure library and can't be attached to new Work Orders. Work Orders that already use it keep their copy.`}
        </Text>
        {error ? <Text tone="negative">{error}</Text> : null}
      </Stack>
    </Modal>
  );
}
